import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'aa-protected-area',
    templateUrl: './protected-area.component.html',
    styleUrls: [
        './protected-area.component.scss'
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ProtectedAreaComponent implements OnInit
{
    @Input() title: string = '';
    @Input() message: string = '';

    constructor() { }

    ngOnInit ()
    {
    }
}
